import { useEffect } from 'react';
import { useUserSessionContext } from '../hooks/contexts/useUserSessionContext';
import { LoadingIndicator } from '../components/LoadingIndicator';

export const LogoutPage = () => {
  const { logout } = useUserSessionContext();

  useEffect(() => {
    logout();
  }, [logout]);

  return <LoadingIndicator isFullScreen />;
};
